/* unplugin-vue-components disabled */import script from "./FlashBox.vue?vue&type=script&setup=true&lang=js"
export * from "./FlashBox.vue?vue&type=script&setup=true&lang=js"

import "./FlashBox.vue?vue&type=style&index=0&id=3d8dae13&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d8dae13"]])

export default __exports__